const isEasingGenerator=easing=>"object"==typeof easing&&Boolean(easing.createAnimation);export{isEasingGenerator};